import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'already-in-team',
    templateUrl: './already-in-team.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlreadyInTeamComponent {}